import { RpcService } from 'rpc';

export interface UsedLetters {
	[key: string]: string[];
}

export interface Term {
	term: string;
	definition: string;
}

export declare interface IGlossaryService extends RpcService {
	used_letters(): Promise<UsedLetters>;
	search_letter(params: { search_char: string[] }): Promise<Term[]>;
	search_text(params: { search: string }): Promise<Term[]>;
}

export const svc: IGlossaryService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `@@glossary.rpc`,

	services: {
		used_letters: {
			parameters: []
		},
		search_letter: {
			parameters: [
				{
					name: 'search_char',
					type: 'array',
					optional: false
				}
			]
		},
		search_text: {
			parameters: [
				{
					name: 'search',
					type: 'string',
					optional: false
				}
			]
		}
	}
}) as IGlossaryService;

export default svc;
